export const FileUploadType = {
    RETAILER_LOGO : "image_retailer_translation_logo",
    RETAILER_COVER: "image_retailer_translation_cover",
    CATEGORY_PICTURE: "category_translation_picture",
    USER_PICTURE: "image_user_picture",
    PRODUCT_PICTURE: "product_picture"
}
